"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createBannerLayout = void 0;
var _editorialFetching = require("@ori/editorial-fetching");
var _common = require("../common");
var _components = require("../components");
var _CtaButtonLayout = require("../components/CtaButtonLayout");
var _styles = require("../components/styles");
var _errors = require("./errors");
var _jsxRuntime = require("react/jsx-runtime");
const LayoutError = (param)=>{
    let { debug, modulePosition, layout } = param;
    return (0, _errors.renderOrThrowError)({
        debug,
        message: "".concat(layout, " must have layout specified correctly."),
        modulePosition,
        layout
    });
};
const createBannerLayout = (param)=>{
    let { banner, debug, modulePosition, renderOnMyPages } = param;
    switch(banner.layout){
        case _editorialFetching.EditorialBannerLayoutEnum.OneMediaCenterBottomText:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.LimitedWidthEditorialsModule, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.OneMediaCenterBottomTextLayout, {
                    banner: banner,
                    debug: debug,
                    modulePosition: modulePosition
                })
            }, "one-media-center-bottom-text-layout");
        case _editorialFetching.EditorialBannerLayoutEnum.OneMediaOverlayLeftText:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.LimitedWidthEditorialsModule, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.OneMediaOverlayTextLayout, {
                    banner: banner,
                    debug: debug,
                    modulePosition: modulePosition,
                    position: _common.OverlayPosition.Left
                })
            }, "one-media-overlay-left-text-layout");
        case _editorialFetching.EditorialBannerLayoutEnum.OneMediaOverlayRightText:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.LimitedWidthEditorialsModule, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.OneMediaOverlayTextLayout, {
                    banner: banner,
                    debug: debug,
                    modulePosition: modulePosition,
                    position: _common.OverlayPosition.Right
                })
            }, "one-media-overlay-right-text-layout");
        case _editorialFetching.EditorialBannerLayoutEnum.FourMedia:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.LimitedWidthEditorialsModule, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.FourMediaLayout, {
                    banner: banner,
                    debug: debug,
                    modulePosition: modulePosition
                })
            }, "four-media-layout");
        case _editorialFetching.EditorialBannerLayoutEnum.Headline:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.LimitedWidthEditorialsModule, {
                paddingOnMobile: true,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.HeadlineLayout, {
                    banner: banner,
                    debug: debug,
                    modulePosition: modulePosition
                })
            }, "headline-layout");
        case _editorialFetching.EditorialBannerLayoutEnum.OneMediaParagraphText:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.LimitedWidthEditorialsModule, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.OneMediaParagraphTextLayout, {
                    banner: banner,
                    debug: debug,
                    modulePosition: modulePosition
                })
            }, "one-media-paragraph-text-layout");
        case _editorialFetching.EditorialBannerLayoutEnum.ParagraphText:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.LimitedWidthEditorialsModule, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.ParagraphTextLayout, {
                    banner: banner,
                    debug: debug,
                    modulePosition: modulePosition
                })
            }, "paragraph-text-layout");
        case _editorialFetching.EditorialBannerLayoutEnum.Quote:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.FullWidthEditorialsModule, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.QuoteLayout, {
                    banner: banner,
                    debug: debug,
                    modulePosition: modulePosition
                })
            }, "quote-layout");
        case _editorialFetching.EditorialBannerLayoutEnum.ThreeMediaRightBottomText:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.LimitedWidthEditorialsModule, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.ThreeMediaRightBottomTextLayout, {
                    banner: banner,
                    debug: debug,
                    modulePosition: modulePosition
                })
            }, "three-media-right-bottom-text-layout");
        case _editorialFetching.EditorialBannerLayoutEnum.BigCtaButton:
        case _editorialFetching.EditorialBannerLayoutEnum.SmallCtaButton:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.LimitedWidthEditorialsModule, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_CtaButtonLayout.CtaButtonLayout, {
                    banner: banner,
                    debug: debug,
                    modulePosition: modulePosition
                })
            }, "cta-button-layout");
        case _editorialFetching.EditorialBannerLayoutEnum.TwoMedia:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.LimitedWidthEditorialsModule, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.TwoMediaLayout, {
                    banner: banner,
                    debug: debug,
                    modulePosition: modulePosition
                })
            }, "two-media-layout");
        case _editorialFetching.EditorialBannerLayoutEnum.TwoMediaRightTopText:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.LimitedWidthEditorialsModule, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.TwoMediaRightTopTextLayout, {
                    banner: banner,
                    debug: debug,
                    modulePosition: modulePosition
                })
            }, "two-media-right-top-text-layout");
        case _editorialFetching.EditorialBannerLayoutEnum.Video:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.LimitedWidthEditorialsModule, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.VideoLayout, {
                    banner: banner,
                    debug: debug,
                    modulePosition: modulePosition
                })
            }, "video-layout");
        case _editorialFetching.EditorialBannerLayoutEnum.VerticalVideo:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.FullWidthEditorialsModule, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.VerticalVideoLayout, {
                    banner: banner,
                    debug: debug,
                    modulePosition: modulePosition
                })
            }, "vertical-video-layout");
        default:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(LayoutError, {
                debug: debug,
                modulePosition: modulePosition,
                layout: "EditorialBanner"
            });
    }
};
exports.createBannerLayout = createBannerLayout;
